const defaultState = () => ({
  details_correlation: {
    description: undefined,
    incidentPerDistinctAlert: [],
    severity: {
      id: 0,
      name: 'Não informado'
    },
    locale: undefined,
    idRuleDocumentation: undefined,
    name: undefined,
  },
  group_correlation: {
    groupSearch: undefined,
    alertSearch: undefined,
    grouping: undefined,
    alert: undefined,
  },
  playbook_correlation: {
    queryPlaybooks: undefined,
  },
  skill_correlation: {
    queryMitreSkills: undefined,
  }
})
export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    details_correlation: (state) => state.details_correlation,
    group_correlation: (state) => state.group_correlation,
    playbook_correlation: (state) => state.playbook_correlation,
    skill_correlation: (state) => state.skill_correlation,
    all: (state) => {
      return {
        ...state.details_correlation,
        ...state.group_correlation,
        ...state.playbook_correlation,
        ...state.skill_correlation,
      }
    }
  },
  mutations: {
    specific_tab: (state, { id, data }) => {
      state[id] = data
    },
    details_correlation: (state, { id, input }) => {
      state.details_correlation[id] = input
    },
    group_correlation: (state, { id, input }) => {
      state.group_correlation[id] = input
    },
    playbook_correlation: (state, { id, input }) => {
      state.playbook_correlation[id] = input
    },
    skill_correlation: (state, { id, input }) => {
      state.skill_correlation[id] = input
    },
    resetAll: (state) => {
      state.details_correlation = defaultState()['details_correlation']
      state.group_correlation = defaultState()['group_correlation']
      state.playbook_correlation = defaultState()['playbook_correlation']
      state.skill_correlation = defaultState()['skill_correlation']
    }
  }
}

